<template>
  <div class="promotions">
    <div class="tab-information-center">
      <button
        class="btn btn-tabs"
        v-for="(tab, i) in tabs"
        :key="i"
        :class="activeTab(tab)"
        @click="navigateTo(tab)"
      >
        {{ $t(tab.name) }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InfoCenterTabNavigation',
  data() {
    return {
      currentTab: null,
    }
  },
  props: {
    tabs: {
      type: Array,
      required: false,
      default: () => [
        { name: 'Support', link: '/information-center/support' },
        { name: 'Notification', link: '/information-center/notification' },
        { name: 'Announcement', link: '/information-center/announcement' },
      ],
    },
  },
  methods: {
    navigateTo(tab) {
      this.currentTab = tab
      this.$router.push({ path: tab.link })
    },
    activeTab(tab) {
      const routePath = this.$route.path
      if (routePath === tab.link) {
        return `active-${tab.name.toLowerCase()}`
      }
      return ''
    },
  },
  mounted() {
    const currentPath = this.$route.path
    this.currentTab = this.tabs.find((tab) => tab.link === currentPath)
  },
}
</script>

<style lang="less" scoped>
@import url(./styles/tab-navigation.less);
</style>



// WEBPACK FOOTER //
// src/pages/InformationCenter/TabNavigation.vue